import Home from "./pages";
import Projects from "./pages/Projects";
import Services from "./pages/Services";
import Team from "./pages/Team";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Team" element={<Team />} />
      </Routes>
    </div>
  );
}

export default App;
